export const ID = '6c39e3c0-4e92-4c45-802f-139b074a92f5';

export const NAME = 'Blog Home';
